export default "__VITE_ASSET__Mme0wSqO__"